import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as internal from 'stream';

@Component({
  selector: 'report-user-card',
  templateUrl: './report-user-card.component.html',
  styleUrls: ['./report-user-card.component.css']
})
export class ReportUserCardComponent implements OnInit {

  constructor(private translate: TranslateService) { }

  @Input() accessEventsUsers:{
    userId: number,
    userName: string,
    photoB64: string,
    similarity: number,
    count: number
  }

  ngOnInit(): void {
  }

}
